var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButterfly6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 177,
    viewBox: "0 0 182 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.059 99.2523L150.706 110.832L154.824 114.967L126 172.037L108.912 95.1168L100.471 129.028V177L59.2941 117.449L57.8319 88.5L55.1765 90.1542L24.7059 81.0561L0 0L120.235 49.6262H182L163.059 99.2523Z",
    fill: "#AADBB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.235 49.6262L133.412 90.1542L150.706 110.832L130.5 92L120.235 49.6262L111.501 106.999L108.912 95.1168L120.235 49.6262L58.375 99.2523L57.8319 88.5L120.235 49.6262Z",
    fill: "#125867"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.412 90.1542L120.235 49.6262L108.912 95.1168L116 126.5L154.824 114.967L126 172.037L116 126.5L108.912 95.1168L100.471 129.028V177L59.2941 117.449L100.471 129.028L108.912 95.1168L120.235 49.6262L57.8319 88.5L55.1765 90.1542L24.7059 81.0561L120.235 49.6262L163.059 99.2523L150.706 110.832L133.412 90.1542Z",
    fill: "#48A7A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterfly6);
export default __webpack_public_path__ + "static/media/butterfly-6.15617a7b7c1eed3906b2885ddcd88c6c.svg";
export { ForwardRef as ReactComponent };